'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _roles = require('config/permissions/roles');

var _account = require('services/account.service');

var _account2 = _interopRequireDefault(_account);

var _account3 = require('./account.component');

var _account4 = _interopRequireDefault(_account3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.app.account', [_angularUiRouter2.default]).component('account', _account4.default).service('AccountService', _account2.default).config(function ($stateProvider) {
  'ngInject';

  $stateProvider.state('account', {
    parent: 'app',
    url: '/account',
    component: 'account',
    data: {
      permissions: {
        only: [_roles.REGULATOR, _roles.USER],
        redirectTo: 'dashboard'
      }
    },
    resolve: {
      accessLevels: function accessLevels(AuthService) {
        return AuthService.getAccessLevels();
      },
      user: function user(AccountService, currentUser) {
        return AccountService.getAccount(currentUser.UserId).then(function (r) {
          return r.data;
        });
      }
    }
  });
}).name;


// WEBPACK FOOTER //
// ./components/app/account/account.module.js